import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class CardExamsInformationAPI extends ComponentAPI {
    setDtProcedimento(value) {
        this.setState({ dtProcedimento: value });
    }
    setStatus(value) {
        this.setState({ status: value });
    }
}
//# sourceMappingURL=card-exams-information-api.js.map